import React from "react";
import { COMPANY } from "../data/site";

/**
 * Rotating circular stamp/seal with text running around the edge
 * and the company logo at the center.
 */
const RotatingStamp = ({
  text = "★ ESS BEE HEATERS PVT. LTD. ★ RENAMED SINCE 2017 ",
  size = 170,
}) => {
  const r = size / 2 - 14;
  const cx = size / 2;
  const cy = size / 2;
  const pathLen = 2 * Math.PI * r;

  return (
    <div
      className="relative inline-block"
      style={{ width: size, height: size }}
      data-testid="rotating-stamp"
    >
      {/* Faint outer ring */}
      <div
        className="absolute inset-0 rounded-full border border-orange-300/30"
        style={{ boxShadow: "0 0 80px -10px rgba(255,138,0,0.55)" }}
      />

      <svg
        viewBox={`0 0 ${size} ${size}`}
        width={size}
        height={size}
        className="rotate-slow"
      >
        <defs>
          <path
            id="stamp-circle"
            d={`M ${cx},${cy} m -${r},0 a ${r},${r} 0 1,1 ${r * 2},0 a ${r},${r} 0 1,1 -${r * 2},0`}
          />
        </defs>
        <text
          fill="#ffd5a3"
          style={{
            fontFamily: "'Geist Mono', monospace",
            fontWeight: 700,
            letterSpacing: "0.05em",
            fontSize: size * 0.07,
          }}
        >
          <textPath
            href="#stamp-circle"
            textLength={pathLen}
            lengthAdjust="spacingAndGlyphs"
          >
            {text}
          </textPath>
        </text>
      </svg>

      {/* Center logo */}
      <div className="absolute inset-0 grid place-items-center pointer-events-none">
        <div className="w-[60%] h-[60%] rounded-full bg-white grid place-items-center shadow-2xl shadow-red-500/30 flicker p-3">
          <img
            src={COMPANY.logo}
            alt="ESS BEE HEATERS"
            className="w-full h-full object-contain"
            data-testid="stamp-logo"
          />
        </div>
      </div>
    </div>
  );
};

export default RotatingStamp;
